import React from 'react';
import { PT_FLAG_TONE } from '../../../patients-list/config';
import type { PtDirectoryPatient } from '../../../patients-list/types';
import { ptFlags } from '../../../patients-list/utils';
import { Icon } from '../../Icon/Icon';

export interface PatientDirectoryFlagsProps {
  patient: PtDirectoryPatient;
}

export function PatientDirectoryFlags({ patient }: PatientDirectoryFlagsProps) {
  const flags = ptFlags(patient);
  if (!flags.length) return null;

  return (
    <div className="mt-[11px] flex flex-wrap gap-[5px] border-t border-[var(--cream-2)] pt-[11px]">
      {flags.map((f, i) => {
        const tn = PT_FLAG_TONE[f.tone]!;
        return (
          <span
            key={i}
            title={f.title || ''}
            className="pt-flag"
            style={{ background: tn.bg, color: tn.fg }}
          >
            <Icon kind={f.icon} size={11} stroke={2} />
            {f.label}
          </span>
        );
      })}
    </div>
  );
}
